import PropTypes from 'prop-types';

import { Button } from 'ui';

import SubscriptionLayout from './SubscriptionLayout';
import { ONBOARDING_STEPS } from '../../core/constants';

const WelcomeStep = ({ setStep }) => {
  return (
    <SubscriptionLayout>
      <div className="relative flex size-full flex-col items-center justify-center px-8">
        <div className="max-w-[436px] space-y-8">
          <div className="space-y-4">
            <h1 className="text-h2 font-semibold">Welcome to DonorSpring!</h1>
            <p className="text-lg">We&apos;re excited to have you in this community.</p>
            <p className="text-lg">
              {' '}
              Your first step is to set up your account. Our step-by-step instructions will guide you, but please
              don&apos;t hesitate to reach out if you need any assistance. Once you are set up, you are free to explore
              the platform!
            </p>
            <p className="text-lg">
              At the end of the guided account setup you will also have the opportunity to schedule a 1:1 onboarding
              call with us; this is where we&apos;ll walk you through the DonorSpring platform and share essential tips
              and best practices.
            </p>
          </div>
          <Button
            title="Continue"
            color="primary"
            size="xl"
            className="w-full"
            onClick={() => setStep(ONBOARDING_STEPS.invoices)}
          />
        </div>
      </div>
    </SubscriptionLayout>
  );
};

WelcomeStep.propTypes = {
  setStep: PropTypes.func.isRequired,
};

export default WelcomeStep;
